import { EnumValues } from 'common/types';
import { stringEnum } from 'common/utils/objects';

export const BookingStates = stringEnum([
	'EXPIRED',
	'UPCOMING',
	'PENDING',
	'ACTIVE',
	'COMPLETED',
	'CANCELLED',
]);

export const BookingPaymentStates = stringEnum(['PAID', 'UNPAID', 'REFUNDED']);

export const BookingPreparationStates = stringEnum(['PREPARED', 'NOT_PREPARED']);

export type BookingState = EnumValues<typeof BookingStates>;
export type BookingPaymentState = EnumValues<typeof BookingPaymentStates>;
export type BookingPreparationState = EnumValues<typeof BookingPreparationStates>;
